import {AdminService} from './admin-service'
import {AuthService} from './auth-service'
import {BannerService} from './banner-service'
import {BlogService} from './blog-service'
import {CampaignService} from './campaign-service'
import {CampaignTemplateService} from './campaign-template-service'
import {ChatService} from './chat-service'
import {CityService} from './city-service'
import {EventService} from './event-service'
import {LikeService} from './like-service'
import {LockService} from './lock-service'
import {PaymentService} from './payment-service'
import {PhotoService} from './photo-service'
import {RegionService} from './region-service'
import {SliderService} from './../services/slider-service'
import {UserService} from './user-service'
import {VisitService} from './visit-service'
import {GiftService} from './gift-service'

angular.module("app").service('AdminService', ['$http', AdminService]);
angular.module("app").service('AuthService', ['$http', '$cookies', '$location', '$route', '$rootScope', '$window', 'toastr', AuthService]);
angular.module("app").service('BannerService', ['$http', BannerService]);
angular.module("app").service("BlogService", ['$http', BlogService]);
angular.module("app").service('CampaignService', ['$http', CampaignService]);
angular.module("app").service('CampaignTemplateService', ['$http', CampaignTemplateService]);
angular.module("app").service('ChatService', ['$http', ChatService]);
angular.module("app").service('CityService', ['$http', CityService]);
angular.module("app").service('EventService', ['$http', '$cookies', EventService]);
angular.module("app").service('LikeService', ['$http', LikeService]);
angular.module("app").service('LockService', ['$http', LockService]);
angular.module("app").service('PaymentService', ['$http', PaymentService]);
angular.module("app").service('PhotoService', ['$http', PhotoService]);
angular.module("app").service('RegionService', ['$http', RegionService]);
angular.module("app").service('SliderService', ['$http', SliderService]);
angular.module("app").service('UserService', ['$http', '$rootScope', 'PhotoService', UserService]);
angular.module("app").service('VisitService', ['$http', VisitService]);
angular.module("app").service('GiftService', ['$http', GiftService]);
